import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export type ApprovalTermDealAdjustment = {
    id: number | null
    status: string | null
    eligible: boolean
    created_at: string | null
    approved_at: string | null
    response_message: string | null
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApprovalTerm = any // will be updated in subsequent PR

export default async function getApprovalTerms(
    applicationUuid: string,
    signal?: AbortSignal,
): Promise<ApprovalTerm[]> {
    try {
        if (!applicationUuid) {
            throw new Error('invalid UUID')
        }

        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/applications/${applicationUuid}/approval-terms/`,
            {
                signal,
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        if (!axios.isCancel(error)) {
            OctaneLogger.axiosError(
                `Failed to get approval terms: ${axiosError.message}`,
                axiosError,
                { applicationUuid },
            )
        }

        throw axiosError
    }
}
